import configuration from '../../configuration';
import ODataFulogicsStore from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { createModel } from '@rematch/core';
import { iRootModel } from '../iRootModel';
import { DataSourceOptions } from 'devextreme/data/data_source';
import insertToCollectionFunc, {
    insertToCollectionPayload,
} from 'fulogics-ui-core/dist/store/helpers/insertToCollectionFunc';

export const COSOrderForwardStepODataEndpoint = `${configuration.API_BASE_URL}/odata/ForwardSteps/Store`;
export const COSOrderForwardStepStore = ODataFulogicsStore(
    {
        url: COSOrderForwardStepODataEndpoint,
        key: 'id',
        keyType: 'String',
    },
    {
        createByCollectionId: (
            collectionId?: string,
            options?: {
                defaultOrderByPolicy?: 'timetable';
            }
        ) => {
            if (!collectionId) return undefined;

            const customQueryParams = {
                defaultOrderByPolicy: options?.defaultOrderByPolicy,
                collectionId: collectionId?.toString(),
            };

            if (!options?.defaultOrderByPolicy) delete customQueryParams.defaultOrderByPolicy;

            return {
                store: COSOrderForwardStepStore,
                reshapeOnPush: true,
                customQueryParams,
            } as DataSourceOptions;
        },
    }
);

export type COSOrderForwardStepState = {};

export const COSOrderForwardStepModel = createModel<iRootModel>()({
    state: {} as COSOrderForwardStepState,

    effects: (dispatch) => ({
        async setLocation(payload: setLocationPayload) {
            let copyOfPayload = Object.assign({}, payload);
            let modelId = payload.id;
            //
            delete (copyOfPayload as any)['id'];
            //
            await COSOrderForwardStepStore.update(modelId, {
                ...copyOfPayload,
            });
        },
        async setPlannedStartDate(payload: setPlannedStartDatePayload) {
            let copyOfPayload = Object.assign({}, payload);
            let modelId = payload.id;
            //
            delete (copyOfPayload as any)['id'];
            //
            await COSOrderForwardStepStore.update(modelId, {
                ...copyOfPayload,
            });
        },
        // async dereserveItems(payload: )
        async deleteItem(payload: deleteItemPayload) {
            await COSOrderForwardStepStore.remove(payload.id);
        },
        async insertToCollection<T>(
            payload: insertOrderForwardStepToCollectionPayload & insertToCollectionPayload<T>
        ) {
            return insertToCollectionFunc({
                ...payload,
                //
                url: '/odata/ForwardSteps',
                store: COSOrderForwardStepStore,
            });
        },
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrderStepForwardData
        {
            return COSOrderForwardStepStore;
        },
    }),
});

export default COSOrderForwardStepModel;

export type insertOrderForwardStepToCollectionPayload = {
    collectionId?: string;
};

export type setLocationPayload = {
    id: string;
    location?: {
        logisticUnitId?: number;
        logisticUnit?: any;
        location?: {
            zipCode?: string;
            city?: string;
            street?: string;
            buildingNumber?: string;
            countryId?: number;
            note?: string;
        };
    };
};

export type setPlannedStartDatePayload = {
    id: string;
    plannedStartDate?: Date | null;
};

export type deleteItemPayload = {
    id?: string;
};
